import React from "react";
import { Routes, Route, NavLink } from "react-router-dom";

import List from "./list";
import View from "./view";
import TemplateList from "./template-list";
import TemplateView from "./template-view";

const Contract = () => {
  return (
    <div className="p-3">
      <div className="flex items-center gap-1 border border-neutral-300 bg-white p-1 rounded-md mb-3 w-fit">
        <Tab to="/legal_document" end>Contracts</Tab>
        <Tab to="/legal_document/templates">Templates</Tab>
      </div>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="/templates" element={<TemplateList />} />
        <Route path="/templates/:id" element={<TemplateView />} />
        <Route path="/:id" element={<View />} />
      </Routes>
    </div>
  );
};

const Tab = ({ to, end, children }) => (
  <NavLink
    to={to}
    end={end}
    className={({ isActive }) => (isActive ? "blue-btn" : "transparent-btn cursor-pointer relative rounded flex items-center")}>
    <div className="flex items-center gap-2 truncate">{children}</div>
  </NavLink>
);

export default Contract;
